/**
 * @desc 通过sku编号集合获取sku简要列表信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuBriefDetailResponseRpcDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuBriefListSkuNos`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
